module.exports = __webpack_public_path__ + "static/media/ServiceUnavailable.26c438d7.png";